module.exports = __webpack_public_path__ + "img/ssyx_32.215aaeab.jpg";